
import * as Geofire from 'geofire-common'
import getHashesNear from 'geohashes-near'

const UNITS = 'meters'

export function getAllGeohashsInBounds(center, bounds) {
  const { lat, lng } = center
  // 取左上的座標，和中間點計算距離，算出矩形的斜邊的一半有多長，作為半徑
  const { nw } = bounds
  const distanceInKm = Geofire.distanceBetween([lat, lng], [nw.lat, nw.lng])
  const radius = parseInt(distanceInKm * 1000)
  const geohashPrecision = getGeohashPrecision([lat, lng], radius)
  const centerGeohash = geohashEncode(center, geohashPrecision)
  const neighbourGeohashesInRadius = getNeighbourGeohashsInRadius(center, geohashPrecision, radius)
  return [centerGeohash, ...neighbourGeohashesInRadius]
}

export function geohashEncode(latlng, precision) {
  const { lat, lng } = latlng
  return Geofire.geohashForLocation([lat, lng], precision)
}

export function getNeighbourGeohashsInRadius(latlng, precision, radius) {
  const { lat, lng } = latlng
  const neighbourGeohashesInRadius = getHashesNear({ latitude: lat, longitude: lng }, precision, radius, UNITS)
  return neighbourGeohashesInRadius
}

// How firebase use geofire-common package https://firebase.google.com/docs/firestore/solutions/geoqueries
// geofire-common src code: https://github.com/firebase/geofire-js/blob/master/packages/geofire-common/src/index.ts
// I found the way of calculating the "geohashPrecision" by tracking geofire-common package's source code
export function getGeohashPrecision(latlng, radius) {
  const queryBits = Math.max(1, Geofire.boundingBoxBits(latlng, radius))
  const geohashPrecision = Math.ceil(queryBits / Geofire.BITS_PER_CHAR)
  return geohashPrecision
}